<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content">
        <div class="go-back" @click="goBack">返回</div>
        <div class="main-title">消息通知</div>

        <div class="main-sub">{{ detail.message_title }}</div>
        <div id="content" style="width:560px;margin:0 auto 50px;text-align: center">

        </div>


      </div>
    </div>
  </div>
</template>

<script>
import {
  skipOrReadStep,
  getDetail,
  getConfig,


  getmyMenu, clientMenu_detail
} from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
export default {
  components: {top, navMenu},
  name: "conference",
  data() {
    return {
      loading: false,
      active: 0,
      content: {
        title_brief: "",
      },
      list: [],
      totals: 0,
      detail: {},
      stepMenuList: []
    };
  },
  mounted() {
    this.getMenu()
    this.detail = JSON.parse(this.$route.query.contacts)
    this.getContent()
  },
  created() {

  },
  methods: {
    // 获取页面信息
    getMenu() {
      let that = this;
      let data = this.$qs.stringify({type: JSON.parse(localStorage.getItem("userdata")).type});
      getmyMenu(data).then((res) => {
        if (res.code == 1) {
          let {data} = res;
          console.log(data, "data")
          this.stepMenuList = data;
          let stepMenuList = data;
          let index = stepMenuList.findIndex(function (item) {
            return item.link_url == "/eventNotification";
          });
          if (stepMenuList[index].children && stepMenuList[index].children.length > 0) {
            that.list = stepMenuList[index].children;
          }
          that.active = index;
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    // 获取内容
    getContent() {
      document.getElementById('content').innerHTML = this.detail.message_content
    },

    // 返回
    goBack() {
      this.$router.back();
    },


  },
};
</script>

<style lang="scss" scoped>
.main-sub {
  // width: 946px;
}

@media only screen and (max-width: 767px) {
  .content {
    padding: 30px 0 130px 0;

  }

}
</style>